import api from '@/api/api'
export default {
  namespaced: true,
  state: {
  },
  mutations: {
    setPlano (state, payload) {
      state.plano = payload
    },
  },
  actions: {
    getPlanos ({ rootState }, values) {
      return new Promise((resolve, reject) => {
        api.post('/property/getPlano', {
          credentials: rootState.login.credentials,
          values: values
        }).then(response => {
          if (response.data.result === 'OK') {
            resolve(response.data)
          } else {
            resolve(null)
          }
        })
          .catch(e => {
            reject(e)
          })
      })
    },
  },
  getters: {
    getPlano (state) {
      return state.plano
    },
  }
}
